<template>
  <div class="quantity-toggle">
    <button @click.prevent="decrement()">&mdash;</button>
    <input
      type="tel"
      name="quantity"
      autocomplete="off"
      v-model="local_value"
      @input="updateIfInstant"
      @blur="update"
      @keyup.enter="update"
    />
    <button @click.prevent="increment()">&#xff0b;</button>
  </div>
</template>

<style lang="scss">
$border: 1px solid #ddd;

.quantity-toggle {
  display: flex;

  input {
    border: 0;
    border-top: $border;
    border-bottom: $border;
    width: 2.5rem;
    text-align: center;
    padding: 0 0.5rem;
  }

  button {
    border: $border;
    padding: 0 0.407rem;
    background: #f5f5f5;
    color: #888;
    font-size: 0.8rem;
    cursor: pointer;
  }
}
</style>

<script>
import throttle from "lodash-es/throttle";

export default {
  data() {
    return {
      local_value: 1,
    };
  },
  mounted() {
    this.local_value = this.value;
  },
  props: {
    value: {},
    instant: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    value(val) {
      this.local_value = val;
    },
  },
  computed: {
    quantity: {
      get() {
        return this.local_value;
      },
      set(val) {
        this.local_value = val;
        if (this.instant) {
          this.$emit("input", this.local_value);
        } else {
          this.update(this.local_value);
        }
      },
    },
  },
  methods: {
    updateIfInstant() {
      if (this.instant) {
        this.update();
      }
    },
    update: throttle(function () {
      if (this.local_value > 0) {
        this.$emit("input", this.local_value);
      } 
    }, 500),
    increment() {
      this.quantity++;
    },
    decrement() {
      if (this.quantity > 1) {
        this.quantity--;
      }
    },
  },
};
</script>
